import React, { Dispatch, memo, ReactNode, SetStateAction } from 'react';
import cn from 'classnames';

import { DynamicIconWrapper, Icons } from '@components/common';

import styles from './ProfileTabSection.module.scss';

export type TTab = {
	title: string;
	value: any;
	iconName?: string;
	isVisible: boolean;
};

interface IProfileTabSectionProps {
	children?: ReactNode;
	currentTab?: string;
	getCurrentTab: () => ReactNode;
	height?: string;
	isFullHeight?: boolean;
	isFullWidthTabs?: boolean;
	isWithoutShadow?: boolean;
	maxHeight?: string;
	maxWidth?: string;
	setCurrentTab: Dispatch<SetStateAction<any>>;
	tabWidth?: string;
	tabs: TTab[];
	containerClassname?: string;
	contentClassName?: string;
}

const ProfileTabSection = ({
	children,
	containerClassname,
	contentClassName,
	currentTab,
	getCurrentTab,
	height = '100%',
	isFullHeight,
	isFullWidthTabs,
	isWithoutShadow,
	maxHeight,
	maxWidth,
	setCurrentTab,
	tabWidth,
	tabs,
}: IProfileTabSectionProps) => {
	const onChangeTab = (tab: keyof TTab) => () => setCurrentTab(tab);

	return (
		<div
			className={cn(
				styles.whiteWrapper,
				styles.mainSection,
				containerClassname,
				{
					[styles.wrapperShadow]: !isWithoutShadow,
					[styles.fullHeight]: isFullHeight,
				},
			)}
			style={{ maxWidth, height: isFullHeight ? '100%' : height, maxHeight }}
		>
			<div className={styles.tabsContainer}>
				<>
					{tabs.filter(tab => tab.isVisible).map((tab, i) => {
						const isActiveTab = currentTab === tab.value;
						const tabClasses = cn(styles.tab, {
							[styles.selected]: isActiveTab,
							[styles.fullWidth]: isFullWidthTabs,
						});

						return (
							<div
								key={`${tab.title}-${i}`}
								className={tabClasses}
								onClick={onChangeTab(tab.value)}
								style={{ width: tabWidth }}
							>
								{tab?.iconName
									&& <DynamicIconWrapper
										icon={Icons[tab.iconName as keyof typeof Icons]}
										isActive={isActiveTab}
									/>
								}
								{tab.title}
							</div>
						);
					})
					}
					{children}
				</>
			</div>
			<div className={cn(styles.body, contentClassName)}>
				{getCurrentTab()}
			</div>
		</div>
	);
};

export default memo(ProfileTabSection);
